import React from 'react';
import { List, Range } from 'immutable';
import moment from 'moment';
import generateSystemMessageContent from '../../helpers/discussions/generateSystemMessageContent';
export var PlainMessageContent = function PlainMessageContent(_ref) {
  var content = _ref.content;
  var plainContent = content.map(function (token) {
    switch (token.type) {
      case 'attachment':
        return token.value.filename;

      case 'team':
        return token.value.name;

      case 'text':
        return token.value.trim();

      case 'user':
        return token.value.unknown ? '*Unknown*' : token.value.displayName;

      default:
        return "(".concat(token.type.toUpperCase(), ")");
    }
  }).join(' ');
  return plainContent.length > 50 ? plainContent.substring(0, 50) + '...' : plainContent;
};
export var SystemMessageContent = function SystemMessageContent(_ref2) {
  var actions = _ref2.actions,
      content = _ref2.content;
  return List(content).map(function (token, i) {
    switch (token.type) {
      case 'message':
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "message-token",
          onClick: function onClick() {
            return actions.history(token.value);
          }
        }, "[ ", /*#__PURE__*/React.createElement(PlainMessageContent, {
          key: i,
          content: token.value.content
        }), " ]");

      case 'team':
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "team-token"
        }, token.value.name);

      case 'text':
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "text-token"
        }, token.value.trim());

      case 'user':
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "user-token"
        }, token.value.unknown ? '*Unknown*' : token.value.displayName);

      case 'attachment':
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "attachment-token"
        }, token.value.name);

      default:
        return /*#__PURE__*/React.createElement("span", {
          key: i
        }, "(", token.type.toUpperCase(), ")");
    }
  }).zip(Range().map(function (i) {
    return /*#__PURE__*/React.createElement("span", {
      key: "space-".concat(i)
    }, "\xA0");
  })).toArray();
};
export var SystemMessage = function SystemMessage(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "system-message"
  }, /*#__PURE__*/React.createElement(SystemMessageContent, {
    actions: props.actions,
    content: props.message.action ? generateSystemMessageContent(props.message.action, props.message.content) : props.message.content
  }), /*#__PURE__*/React.createElement("span", {
    className: "timestamp"
  }, moment(props.message.createdAt).format('h:mma')));
};